// extracted by mini-css-extract-plugin
export default {"headerContainer":"Error_headerContainer__MW6+r","errorIcon":"Error_errorIcon__Fp2Kq","title":"Error_title__eED79"};